@if (product.producto && product.info) {
  <div class="{{ product.producto }}">
    <router-outlet></router-outlet>
    <app-footer></app-footer>
    <app-modal></app-modal>
    <app-modal-alternative></app-modal-alternative>
    <app-loading></app-loading>
  </div>
}